import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const DEFAULTS = {
  hero_word1: "GOOD",
  hero_word2: "GRIEF",
  hero_subtitle: "worldwide.",
  hero_cta: "→ Get on the launch list",
  hero_ticker_left: "N 40.7128° / W 74.0060°",
  hero_ticker_center: "Streetwear · Skate · Punk · Grunge",
  hero_ticker_right: "Drop 01 / Loading",
  hero_scroll: "Scroll ↓",
  hero_transit: "A lifestyle in transit",
  manifesto_label: "[ Manifesto ] — what we're about",
  manifesto_ch1_title: "Grief is a uniform.",
  manifesto_ch1_body:
    "We build for the ones who wear their contradictions loud — thrift-torn and tailored, sacred and profane. Good Grief is the space between the skatepark and the runway.",
  manifesto_ch2_title: "Curated, not manufactured.",
  manifesto_ch2_body:
    "Originals cut the future in-house. Faucet Collective sources the rare, the vintage, the preowned. Everything else is Goods. No filler, no noise, no apologies.",
  manifesto_ch3_title: "Underground, on purpose.",
  manifesto_ch3_body:
    "Punk taught us the doors. Hip-hop taught us the voice. Skateboarding taught us to fall and stand. This is culture, photocopied and passed hand to hand.",
  collections_heading: "FOUR CORNERS",
  collections_blurb:
    "Four ways into the world. One attitude. Explore the divisions launching with Drop 01.",
  collection_order: "originals,faucet,skate,goods",
  media_hero: "https://images.unsplash.com/photo-1547442991-a51706bf3a3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  media_originals: "https://images.unsplash.com/photo-1559697242-a465f2578a95?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  media_faucet: "https://images.unsplash.com/photo-1647664856968-880b8eccd588?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  media_skate: "https://images.unsplash.com/photo-1649281610716-94e4ee026d91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  media_goods: "https://images.pexels.com/photos/10132110/pexels-photo-10132110.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  bento_originals: "https://images.pexels.com/photos/3944692/pexels-photo-3944692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  bento_faucet: "https://images.pexels.com/photos/1670770/pexels-photo-1670770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  bento_skate: "https://images.unsplash.com/photo-1547447134-cd3f5c716030?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bento_goods: "https://images.unsplash.com/photo-1591311337241-cecfd26f1da1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  col_originals_title: "GG ORIGINALS",
  col_originals_tagline: "In-House Line",
  col_originals_desc:
    "The house cut. Made in-house, worn worldwide — heavyweight staples and statement pieces built to outlive the season.",
  col_faucet_title: "FAUCET COLLECTIVE",
  col_faucet_tagline: "Curated · Vintage · Preowned",
  col_faucet_desc:
    "The dig, done for you. Rare non-in-house apparel, archive vintage and preowned grails, sourced with a ruthless eye.",
  col_skate_title: "SKATE",
  col_skate_tagline: "Boards · Hardware · Culture",
  col_skate_desc:
    "Decks, trucks, wheels and the stories that come with the scars. Built for the session, not the shelf.",
  col_goods_title: "GOODS",
  col_goods_tagline: "Objects · Print · Accessories",
  col_goods_desc:
    "The odds and ends. Zines, patches, hardware and artifacts that finish the fit and fill the shelf.",
  signup_label: "[ Launch List ] — no spam, just grief",
  signup_heading: "BE FIRST\nTHROUGH\nTHE DOOR.",
  signup_body:
    "Drop 01 is coming. Leave your email and get early access, secret sizes and the keys before the storefront opens.",
  signup_button: "Join the list →",
  signup_success: "✓ You're on the list. Watch your inbox — grief incoming.",
  footer_tagline: "Worldwide — Est. in transit",
  footer_rights: "All rights reserved / no rights respected",
  nav_join: "Join List",
  social_instagram: "",
  social_tiktok: "",
  social_twitter: "",
  social_youtube: "",
  social_email: "",
};

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);

  const value = { content, setContent };
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentContext);
  const content = ctx?.content || DEFAULTS;
  const t = useCallback((key) => content[key] ?? DEFAULTS[key] ?? "", [content]);
  return { t, content, setContent: ctx?.setContent };
}
